// 相同
export const equal = (column) => `${column}:equal`

// 以条件为开头
export const startswith = (column) => `${column}:startswith`

// 包含多个
export const filterIN = (column) => `${column}:in`

// none
export const none = (column) => `${column}:null`
// 之间
export const gte = (column) => `${column}:gte`
export const lte = (column) => `${column}:lt`
